import { useQuery } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { useCurrentJobId } from "@/hooks/useCurrentJobId";
import { guacHttpClient } from "@/lib/http";
import { CandidacyAgenticScoreChange, HttpResponse } from "@/types";

export function useGetCandidacyAgenticScoreChanges({
  candidacyId,
}: {
  candidacyId: string;
}) {
  const companyId = useCurrentCompanyId();
  const jobId = useCurrentJobId();

  return useQuery({
    queryKey: ["candidacy_agentic_score_changes", companyId, jobId, candidacyId],
    queryFn: async () => {
      const path = `companies/${companyId}/jobs/${jobId}/candidacies/${candidacyId}/agentic-score-changes`;
      const res = await guacHttpClient.get<
        CandidacyAgenticScoreChange[],
        HttpResponse<CandidacyAgenticScoreChange[]>
      >(path);
      return res.data;
    },
  });
}
